import React, { useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../redux/features/authSlice";
import RouteNames from "../../AppRoutes/RouteName";
import EmptyModal from "./EmptyModal";
import UserProfileModal from "./UserProfileModal";

const PAGE_META = {
   "/dashboard": {
      title: "Dashboard",
      subtitle: "Overview of your organization operations",
   },
   "/": {
      title: "Dashboard",
      subtitle: "Overview of your organization operations",
   },
   "/settings": {
      title: "Settings",
      subtitle: "System configurations and generic master data",
   },
   "/settings/units": {
      title: "Unit Management",
      subtitle: "Configure global units of measurement",
   },
   "/settings/preferences": {
      title: "System Preferences",
      subtitle: "Configure global system defaults and formats",
   },
};

const formatLabel = (segment = "") =>
   segment
      .replace(/-/g, " ")
      .split(" ")
      .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : ""))
      .join(" ");

const getInitials = (text = "") => {
   const parts = text.trim().split(/\s+/).filter(Boolean);
   if (!parts.length) return "U";
   if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
   return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};



const Header = () => {
   const dispatch = useDispatch();
   const location = useLocation();
   const navigate = useNavigate();
   const authData = useSelector((state) => state?.auth?.user?.data);
   const user = authData?.user;
   const roles = authData?.roles || [];
   const roleDisplay = roles.length > 0 ? roles[0] : (user?.role_name || user?.role || "User");
   const displayName = user?.name || "User";

   const [isLogoutOpen, setIsLogoutOpen] = useState(false);
   const [isProfileOpen, setIsProfileOpen] = useState(false);
   const [searchValue, setSearchValue] = useState("");

   const handleLogout = () => {
      dispatch(logout());
   };

   return (
      <>
         <nav className="main-header navbar navbar-expand navbar-white navbar-light oil-header">
            <div className="oil-header__left">
               <a
                  className="oil-header__menu-btn"
                  data-widget="pushmenu"
                  href="#"
                  role="button"
                  aria-label="Toggle sidebar"
               >
                  <i className="fas fa-bars" />
               </a>

            </div>

            <div className="oil-header__right">
               <div className="oil-header__search">
                  <i className="fas fa-search oil-header__search-icon" />
                  <input
                     type="search"
                     className="oil-header__search-input"
                     placeholder="Search here..."
                     value={searchValue}
                     onChange={(e) => setSearchValue(e.target.value)}
                     aria-label="Search"
                  />
               </div>

               <button
                  type="button"
                  className="oil-header__notify"
                  aria-label="Notifications"
               >
                  <i className="far fa-bell" />
                  <span className="oil-header__notify-badge">3</span>
               </button>

               <div className="nav-item dropdown oil-header__user-dropdown">
                  <a
                     className="oil-header__user"
                     data-toggle="dropdown"
                     href="#"
                     role="button"
                     aria-haspopup="true"
                     aria-expanded="false"
                     style={{ display: "flex", alignItems: "center", textDecoration: "none" }}
                  >
                     <span className="oil-header__avatar" aria-hidden="true" style={{ display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        {getInitials(displayName)}
                     </span>
                     <div style={{ display: "flex", flexDirection: "column", lineHeight: "1.2", textAlign: "left", marginLeft: "12px", marginRight: "12px", justifyContent: "center" }}>
                        <span className="oil-header__user-name" style={{ margin: 0, padding: 0, fontSize: "0.9rem", fontWeight: "600", color: "#1e293b" }}>{displayName}</span>
                        <span style={{ margin: 0, padding: 0, fontSize: "0.75rem", color: "#64748b", fontWeight: "500", marginTop: "2px" }}>{roleDisplay}</span>
                     </div>
                     <i className="fas fa-chevron-down oil-header__user-caret" style={{ marginLeft: "auto", fontSize: "0.8rem", color: "#94a3b8" }} />
                  </a>
                  <div className="dropdown-menu dropdown-menu-right oil-header__dropdown-menu">
                     <button
                        type="button"
                        className="dropdown-item"
                        onClick={() => setIsProfileOpen(true)}
                     >
                        <i className="fas fa-user mr-2 text-primary" />
                        My Profile
                     </button>
                     <button
                        type="button"
                        className="dropdown-item"
                        onClick={() => navigate(RouteNames.settings)}
                     >
                        <i className="fas fa-cog mr-2 text-primary" />
                        Settings & Masters
                     </button>
                     <div className="dropdown-divider" />
                     <button
                        type="button"
                        className="dropdown-item text-danger"
                        onClick={() => setIsLogoutOpen(true)}
                     >
                        <i className="fas fa-power-off mr-2" />
                        Logout
                     </button>
                  </div>
               </div>
            </div>
         </nav>

         <EmptyModal
            showModal={isLogoutOpen}
            handleCloseModal={() => setIsLogoutOpen(false)}
         >
            <div className="d-flex flex-column align-items-center pb-3">
               <p className="h3">Are you sure you want to logout?</p>
               <div className="d-flex mt-3">
                  <button
                     className="btn btn-danger mr-3"
                     style={{ width: "120px" }}
                     onClick={handleLogout}
                  >
                     Yes
                  </button>
                  <button
                     className="btn btn-success"
                     style={{ width: "120px" }}
                     onClick={() => setIsLogoutOpen(false)}
                  >
                     No
                  </button>
               </div>
            </div>
         </EmptyModal>
         
         <UserProfileModal 
            show={isProfileOpen} 
            onHide={() => setIsProfileOpen(false)} 
            user={user}
         />
      </>
   );
};

export default Header;
